import { ApplicationState } from 'application/redux';
import { clearAccordionTable } from 'core/table-accordion/redux/actions';
import { connect } from 'react-redux';
import { fetch, getAssociatedDevices, getTimelineRecordings } from '../../redux/actions';
import RecordingsComponent from './RecordingsComponent';


function mapStateToProps(state: ApplicationState) {
  return {
    npvr: state.npvr,
  };
}

export default connect(mapStateToProps, {
  fetch,
  getTimelineRecordings,
  clearAccordionTable,
  getAssociatedDevices,
})(RecordingsComponent);
